import React, { useState, useEffect } from 'react';
import { Select } from 'antd';
import firebaseDb from '../firebase';
import { collection, getDocs } from 'firebase/firestore';

export default (props) => {
    let { record, setRecord, name, disabled } = props;
    let [questionSets, setQuestionsSets] = useState([]);

    let get = async () => {

        const questionSetRef = collection(firebaseDb, 'questionSet');
        const questionSetSnapshot = await getDocs(questionSetRef);
        const questionSetList = questionSetSnapshot.docs.map((doc) => {
            return {
                id: doc.id,
                ...doc.data(),
            }
        });
        setQuestionsSets(questionSetList)
    }

    useEffect(() => {
        get()
    }, [])

    return <Select  disabled={disabled} className="button4" value={record[name] || []} mode='single' placeholder="Soru Seti Seçin"
        onChange={v => setRecord({ ...record, [name]: v })}>
        {(questionSets) && questionSets.map(b =>
            <Select.Option key={b.id} value={b.id} >{b.name}</Select.Option>)}
    </Select>;
};